import { useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SupportRequestForm from "@/components/SupportRequestForm";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { SUPPORT_EMAIL, type SupportRequestType } from "@/config/contact";

const TYPES: { value: SupportRequestType; label: string }[] = [
  { value: "contact", label: "General contact" },
  { value: "support", label: "Support / help" },
  { value: "review_report", label: "Report a review" },
  { value: "account_deletion", label: "Delete my account" },
  { value: "dmca", label: "DMCA / copyright notice" },
  { value: "privacy", label: "Privacy request" },
];

const ContactPage = () => {
  const [type, setType] = useState<SupportRequestType>("contact");
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container max-w-xl py-12">
        <h1 className="font-serif text-3xl text-foreground mb-2">Contact us</h1>
        <p className="text-sm text-muted-foreground mb-6">
          All requests reach our team at{" "}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-primary hover:underline">
            {SUPPORT_EMAIL}
          </a>
          . Pick a category so we can route your message faster.
        </p>

        <div className="rounded-2xl border border-border bg-card p-6 shadow-card space-y-5">
          <div className="space-y-1.5">
            <Label htmlFor="contact-type">Request type</Label>
            <Select value={type} onValueChange={(v) => setType(v as SupportRequestType)}>
              <SelectTrigger id="contact-type">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {TYPES.map((t) => (
                  <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <SupportRequestForm key={type} requestType={type} submitLabel="Send message" />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
